import * as React from 'react';
import { Box } from '@mui/material';
import About from './About';
import Works from './Works';
import Services from './Services';
import Location from './Location';
import ComputersCanvas from '../components/Computer';

export default function Home() {
    return (                                    
        <Box>
            <div id='home' style={{ height: 60 }}></div>
            <Box height={{ xs: 500, md: 800 }}><ComputersCanvas /></Box>
            {/* <div id='about' style={{ height: 80 }}></div>
            <About /> */}
            <div id='works' style={{ height: 80 }}></div>
            <Works />
            <div id='services' style={{ height: 80 }}></div>
            <Services />
            <div id='location' style={{ height: 80 }}></div>
            <Location />
            <div id='contact' style={{ height: 80 }}></div>
        </Box>                     
    )
}